<template>
  <div>
    <b-modal
      ref="mdlProcedimentoFormulario"
      :title="title"
      ok-title="Salvar"
      cancel-title="Cancelar"
      size="lg"
      @ok.prevent="salvar"
      @hidden="limpar"
      @shown="validacao"
      centered
    >
      <form ref="frmProcedimentoFormulario">
        <b-form-group label="Nome:" label-for="procedimento-nome">
          <b-form-input
            id="procedimento-nome"
            name="nome"
            v-model="formulario.nome"
            size="sm"
          ></b-form-input>
        </b-form-group>

        <b-row>
          <b-col>
            <b-form-group label="Código:" label-for="procedimento-codigo">
              <b-form-input
                id="procedimento-codigo"
                name="codigo"
                v-model="formulario.codigo"
                size="sm"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group label="Preço:" label-for="procedimento-preco">
              <b-form-input
                id="procedimento-preco"
                name="preco"
                v-model="formulario.preco"
                size="sm"
                data-inputmask="'alias': 'currency'"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group
              label="Idade mínima:"
              label-for="procedimento-idade-minima"
            >
              <b-form-input
                id="procedimento-idade-minima"
                name="idade_minima"
                v-model="formulario.idade_minima"
                size="sm"
                data-inputmask="'alias': 'integer', 'min': 0, 'max': 130"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group
              label="Idade máxima:"
              label-for="procedimento-idade-maxima"
            >
              <b-form-input
                id="procedimento-idade-maxima"
                name="idade_maxima"
                v-model="formulario.idade_maxima"
                size="sm"
                data-inputmask="'alias': 'integer', 'min': 0, 'max': 130"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="3">
            <b-form-group
              label="Quantidade máxima:"
              label-for="procedimento-quantidade-maxima"
            >
              <b-form-input
                id="procedimento-quantidade-maxima"
                name="quantidade_maxima"
                v-model="formulario.quantidade_maxima"
                size="sm"
                data-inputmask="'alias': 'integer', 'min': 1, 'max': 20"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </form>
    </b-modal>
  </div>
</template>

<script>
import ProcedimentoService from "@/core/services/procedimento.service";

import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import Swal from "sweetalert2";
import Inputmask from "@/core/plugins/inputmask";
import { min } from "moment";

export default {
  name: "procedimento-formulario",

  data() {
    return {
      formulario: {
        id: null,
        codigo: "",
        nome: "",
        preco: "",
        idade_minima: null,
        idade_maxima: null,
        quantidade_maxima: null,
      },
    };
  },

  methods: {
    exibirModal(procedimento) {
      if (procedimento) {
        this.formulario.id = procedimento.id;
        this.formulario.codigo = procedimento.codigo;
        this.formulario.nome = procedimento.nome;
        this.formulario.preco = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(procedimento.preco);
        this.formulario.idade_minima = procedimento.idade_minima;
        this.formulario.idade_maxima = procedimento.idade_maxima;
        this.formulario.quantidade_maxima = procedimento.quantidade_maxima;
      }

      this.$refs.mdlProcedimentoFormulario.show();
    },

    async salvar() {
      let formulario = { ...this.formulario };

      await this.fv.validate().then((status) => {
        if (status === "Valid") {
          ProcedimentoService.salvar(formulario)
            .then(() => {
              this.$emit("atualizar");
              this.$refs.mdlProcedimentoFormulario.hide();

              Swal.fire({
                icon: "success",
                title: "Sucesso!",
                text: "Procedimento salvo com sucesso.",
              });
            })
            .catch((error) => {
              if (error.response.status === 422) {
                Object.entries(error.response.data.errors).forEach(
                  ([key, value]) => {
                    this.fv
                      .updateValidatorOption(key, "blank", "message", value[0])
                      .updateFieldStatus(key, "Invalid", "blank");
                  }
                );
              }
            });
        }
      });
    },

    validacao() {
      const frmProcedimentoFormulario = this.$refs.frmProcedimentoFormulario;
      Inputmask().mask(
        frmProcedimentoFormulario.querySelectorAll("[data-inputmask]")
      );

      this.fv = formValidation(frmProcedimentoFormulario, {
        fields: {
          codigo: {
            validators: {
              notEmpty: {
                message: "Preenchimento obrigatório.",
              },
              blank: {},
            },
          },
          nome: {
            validators: {
              notEmpty: {
                message: "Preenchimento obrigatório.",
              },
              blank: {},
            },
          },
          preco: {
            validators: {
              notEmpty: {
                message: "Preenchimento obrigatório.",
              },
              blank: {},
            },
          },
          idade_minima: {
            validators: {
              notEmpty: {
                message: "Preenchimento obrigatório.",
              },
              min: {
                value: 0,
                message: "Valor mínimo é 0.",
              },
              max: {
                value: 130,
                message: "Valor máximo é 130.",
              },
              blank: {},
            },
          },
          idade_maxima: {
            validators: {
              notEmpty: {
                message: "Preenchimento obrigatório.",
              },
              min: {
                value: 0,
                message: "Valor mínimo é 0.",
              },
              max: {
                value: 130,
                message: "Valor máximo é 130.",
              },
              blank: {},
            },
          },
          quantidade_maxima: {
            validators: {
              notEmpty: {
                message: "Preenchimento obrigatório.",
              },
              min: {
                value: 1,
                message: "Valor mínimo é 1.",
              },
              max: {
                value: 20,
                message: "Valor máximo é 20.",
              },
              blank: {},
            },
          },
        },
        plugins: {
          trigger: new Trigger(),
          bootstrap: new Bootstrap(),
        },
      });
    },

    limpar() {
      this.formulario.id = null;
      this.formulario.codigo = "";
      this.formulario.nome = "";
      this.formulario.preco = "";
      this.formulario.idade_minima = null;
      this.formulario.idade_maxima = null;
      this.formulario.quantidade_maxima = null;
    },
  },

  computed: {
    title() {
      return this.formulario.id ? "Editar Procedimento" : "Novo Procedimento";
    },
  },

  beforeDestroy: function () {
    if (this.fv) {
      this.fv.destroy();
    }
  },
};
</script>

<style scoped>
/deep/ .custom-checkbox .custom-control-label::before {
  top: 0.1rem !important;
}
/deep/ .custom-checkbox .custom-control-label::after {
  top: 0.1rem !important;
}
</style>
